import { create } from 'zustand';

import { nestedLocationsApi } from '../axios/nestedLocations';
import {
  buildLocationIndexes,
  LocationsIndexes,
} from '../components/Locations/utils/LocationsHelpers';
import { NestedLocation } from '../types/nestedLocations';

const LIMIT_PER_PAGE = 10000;

interface NestedLocationStoreState {
  locationsIndex: LocationsIndexes;
  isLoading: boolean;
  error: boolean;
  actions: {
    loadAllLocations: () => Promise<void>;
  };
}

export const useNestedLocationStore = create<NestedLocationStoreState>((set, get) => ({
  locationsIndex: {
    locationById: new Map<number, NestedLocation>(),
    childrenByParentId: new Map<number, number[]>(),
  },
  isLoading: false,
  error: false,
  actions: {
    loadAllLocations: async () => {
      const { isLoading } = get();

      if (isLoading) return;

      set({ isLoading: true, error: false });

      let lastId: number | null = null;
      let allLocations: NestedLocation[] = [];
      let hasMore = true;
      let safetyCounter = 0;

      try {
        while (hasMore && safetyCounter < 10) {
          try {
            const { locations, has_more, last_id } = await nestedLocationsApi.getPaginatedLocations(
              {
                after_id: lastId,
                limit: LIMIT_PER_PAGE,
              },
            );

            allLocations = [...allLocations, ...locations];

            lastId = last_id;
            hasMore = has_more;
            safetyCounter += 1;
          } catch (error) {
            console.error('Error(useNestedLocationStore/loadAllLocations):', error);
            break;
          }
        }

        const locationsIndex = buildLocationIndexes(allLocations);
        set({ locationsIndex, isLoading: false });
      } catch (error) {
        set({ isLoading: false, error: true });
      }
    },
  },
}));
